import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../utils/axios";

const PAGE_LABELS: Record<string, string> = {
  "/":          "Home",
  "/time-off":  "Time-off",
  "/leaves":    "Leaves",
  "/swap":      "Swap",
  "/profile":   "Profile",
};

export function useActivityTracker() {
  const { pathname } = useLocation();
  const lastTracked = useRef<string>("");

  useEffect(() => {
    if (pathname === lastTracked.current) return;
    lastTracked.current = pathname;
    const label = PAGE_LABELS[pathname];
    if (label) {
      api.post("employee/activityLog", { page: label }).catch(() => {});
    }
  }, [pathname]);
}
